<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>商品</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/exam/list' }">我的题库</el-breadcrumb-item>
        <el-breadcrumb-item>题库报错</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">题库报错</h2>
        </div>
        <div class="right">
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="题库名称">
          <el-input v-model.trim="query.exam_keyword"
                    placeholder="输入题库名称"
                    @input="fetchList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="章节">
          <el-input v-model.trim="query.chapter_keyword"
                    placeholder="输入章节"
                    @input="fetchList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="小节">
          <el-input v-model.trim="query.child_chapter_keyword"
                    placeholder="输入小节"
                    @input="fetchList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="试卷">
          <el-input v-model.trim="query.paper_keyword"
                    placeholder="输入试卷"
                    @input="fetchList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="query.bug_types"
                     placeholder="请选择"
                     @change="fetchList(true)"
                     clearable
                     multiple
                     collapse-tags>
            <el-option v-for="item in filters.bug_type"
                       :key="item.id"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.modify_status"
                     placeholder="请选择"
                     @change="fetchList(true)">
            <el-option v-for="item in filters.modify_status"
                       :key="item.id"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          clearable
                          @change="fetchList(true)"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">错题列表</h3>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="ID"
                           width="80"
                           fixed="left"
                           align="center"></el-table-column>
          <el-table-column prop="exam_name"
                           label="题库名称"
                           width="300"
                           align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="chapter_name"
                           label="章节名称"
                           width="300"
                           align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="paper_name"
                           label="小节名称"
                           width="300"
                           align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="item_sort"
                           label="题号"
                           width="80"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.item_sort+1
             }}</template>
          </el-table-column>
          <el-table-column label="错误类型"
                           width="300"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{formateBug_type(scope.row.bug_type)}}
            </template>
          </el-table-column>
          <el-table-column prop="detail"
                           label="本题错误详情或建议"
                           width="300"
                           align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column label="图片"
                           align="center"
                           width="200">
            <template slot-scope="scope"
                      v-if="scope.row.picture_url">
              <el-image style="max-height:40px;height:40px;margin:0px 16px;"
                        v-for="(item,index) in scope.row.picture_url.split(',')"
                        :key="index"
                        :src="item"
                        @click="openViewer(item)"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="状态"
                           width="80"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag size="mini"
                      v-if="scope.row.modify_status==1">已处理</el-tag>
              <el-tag type="danger"
                      size="mini"
                      v-if="scope.row.modify_status==0">未处理</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="提交时间"
                           align="center"
                           show-overflow-tooltip
                           width="150">
            <template slot-scope="scope">
              {{scope.row.create_time?$moment(scope.row.create_time).format("YYYY-MM-DD HH:mm"):"无"}}
            </template>
          </el-table-column>
          <el-table-column label="修改时间"
                           align="center"
                           width="150"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.modify_time?$moment(scope.row.modify_time).format("YYYY-MM-DD HH:mm"):"无"}}
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           align="center"
                           width="150">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handleToDetail(scope.row)">详情</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <el-image-viewer v-if="showViewer"
                     :url-list="tableImg"
                     :on-close="closeViewer" />
  </div>
</template>

<script>
import { examBugReportlist } from '@/api/exam'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  components: {
    ElImageViewer,
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      createDatetime: '',
      tableImg: [],
      showViewer: false,
      filters: {
        bug_type: [
          { label: '题干内容错误', value: '0' },
          { label: '内容选项错误', value: '1' },
          { label: '正确答案不匹配', value: '2' },
          { label: '题目错误解析', value: '3' },
          { label: '错别字', value: '4' },
        ],
        modify_status: [
          { label: '未处理', value: '0' },
          { label: '已处理', value: '1' },
        ],
      },
    }
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.start_create_time = this.$moment(value[0]).valueOf()
        this.query.end_create_time = this.$moment(value[1]).valueOf()
      } else {
        this.query.start_create_time = ''
        this.query.end_create_time = ''
        this.fetchList(true)
      }
    },
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)
      if (params.bug_types) {
        params.bug_types = params.bug_types.join(',')
      }
      examBugReportlist(params).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },

    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.bug_types) {
        this.query.bug_types = this.query.bug_types.split(',')
      }
      if (this.query.start_create_time && this.query.end_create_time) {
        this.createDatetime = [
          this.$moment(Number(this.query.start_create_time)),
          this.$moment(Number(this.query.end_create_time)),
        ]
      }
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query)
      if (params.bug_types) {
        params.bug_types = params.bug_types.filter((v) => v).join(',')
      }
      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        })
    },
    openViewer(url) {
      this.tableImg = [url]
      this.showViewer = true
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false
    },
    handleToDetail(item) {
      window.open(`/exam/bugreport/detail/${item.id}`)
      // this.$router.push(`/exam/bugreport/detail/${item.id}`)
    },
    formateBug_type(value) {
      if (value) {
        let val = value.split(',').map((v) => {
          return this.filters.bug_type.find((t) => {
            return v == t.value
          }).label
        })
        return val.join('，')
      } else {
        return '无'
      }
    },
  },
}
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
.el-tag {
  margin: 0px 5px;
}
.tag-wrap {
  text-align: left;
}
</style>
